import { Component, OnInit } from '@angular/core';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { ApiServicesService } from 'src/app/services/apiServices/api-services.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-privacypolicy',
  templateUrl: './privacypolicy.component.html',
  styleUrls: ['./privacypolicy.component.scss']
})
export class PrivacypolicyComponent implements OnInit{
  myProfile: any = true;
  isPrivacyPolicy: boolean = false;
  privacyPolicyData: any = {};

  constructor(
    private commonService: CommonService,
    private service: ApiServicesService,
  ){}
  ngOnInit(): void {
    window.scrollTo(0, 0);  
    this.PrivacyPolicesAPIData();
  }
  
  PrivacyPolicesAPIData() {
    const payload = {
      alias: 'privacy-policy',
    };
    this.service.post(payload, API_ROUTES.PermissionsPolicyData.PermissionsPolicyDataList, {})
      .subscribe((res) => {
        if (res.success) {
          this.privacyPolicyData = res.data;
          console.log("res",res.data)
        } else {
          console.error('Failed to fetch Terms of Use', res.message);
        }
      }
      );
  }

  goBack() {
    this.commonService.goBack();
  }

  onToggleChange () {
   this.isPrivacyPolicy = !this.isPrivacyPolicy;
  }
}
